<template>
  <nav class="bg-black fixed w-full z-20 top-0 left-0 border-b border-black">
    <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
      <a href="/" class="flex items-center">


        <div class="flex items-center">
          <!-- <img class="w-10 h-10 mr-2" src="/img/logo.png" alt="Cloudamai Logo"> -->
        </div>

        <!-- Place your logo here -->
        <!-- <span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
            Cloudamai
          </span> -->

      </a>
      <div class="flex md:order-2">
        <!-- <button type="button" class="text-black bg-white-700  font-medium rounded-lg text-sm px-4 py-2 text-center mr-3 md:mr-0 ">Login</button> -->
        <button onclick="window.location.href='/signup'" type="button"
          class="text-white bg-gradient-to-b from-[#3FADBC] to-[#1c565d] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center ml-6 md:ml- md:mr-0 ">Get
          started</button>


        <button data-collapse-toggle="navbar-sticky" type="button"
          class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          aria-controls="navbar-sticky" aria-expanded="false">
          <span class="sr-only">Open main menu</span>
          <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15" />
          </svg>
        </button>
      </div>
      <div class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1 ml-auto" id="navbar-sticky">
        <ul
          class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg md:flex-row md:space-x-8 md:mt-0 md:border-0 ">
          <li class="menu-item ml-auto">
            <a href="/"
              class="block py-3 pl-2 pr-5 text-white rounded  md:hover-bg-transparent md:hover-text-blue-700 md:p-0  dark-text-white dark:hover-bg-gray-700 dark-hover-text-white md-dark-hover-bg-transparent dark-border-gray-700">Home</a>
          </li>
          <li class="menu-item">
            <a href="/about"
              class="block py-3 pl-2 pr-5 text-white rounded  md:hover-bg-transparent md:hover-text-blue-700 md:p-0  dark-text-white dark:hover-bg-gray-700 dark-hover-text-white md-dark-hover-bg-transparent dark-border-gray-700">About</a>
          </li>
          <li class="menu-item">
            <a href="/contact"
              class="block py-3 pl-2 pr-5 text-white rounded  md:hover-bg-transparent md:hover-text-blue-700 md:p-0  dark-text-white dark:hover-bg-gray-700 dark-hover-text-white md-dark-hover-bg-transparent dark-border-gray-700">Contact</a>
          </li>
        </ul>
      </div>

    </div>
  </nav>
</template>

<script setup lang="ts">
import { useCounterStore } from '@/stores/counter'

const counter = useCounterStore()
// console.log("myCount", counter.count)
</script>
